module.exports = __webpack_public_path__ + "static/media/ios-person-add.9b7a219d.svg";